module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contianer"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": "",
      "loop": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('CarouselItem', [_c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bg_01.jpg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('CarouselItem', [_c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bg_02.jpg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('CarouselItem', [_c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bg_03.jpg"),
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-navbar"
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("登录")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-container"
  }, [_c('Row', {
    staticClass: "row",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('h2', [_vm._v("HEAD")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('h2', [_vm._v("HEAD")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('h2', [_vm._v("HEAD")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1)])], 1), _vm._v(" "), _c('Row', {
    staticClass: "wrap",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('h2', [_vm._v("First featurette heading. ")]), _vm._v(" "), _c('p', [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', {
    staticClass: "wrap-content"
  })])], 1), _vm._v(" "), _c('Row', {
    staticClass: "wrap",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', {
    staticClass: "wrap-content"
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('h2', [_vm._v("First featurette heading. ")]), _vm._v(" "), _c('p', [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "wrap",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("vue")]), _vm._v(" "), _c('Col', {
    staticClass: "wrap-right",
    attrs: {
      "span": "8"
    }
  }, [_vm._v("© 2017 Company, Inc. ·")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Work")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602501ef","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/views/Home.vue
// module id = G5xB
// module chunks = 0